import React from "react";
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import moment from "moment";
import { Button, Card, Label, Message } from "semantic-ui-react";
import { withTranslation } from "react-i18next";
import Invoice from "~/models/Invoice/Invoice";
import InvoiceTable from "~/modules/BillingCentral/components/InvoiceTable";
import InvoicePaymentStatus from "~/constants/Invoice/InvoicePaymentStatus";

const InvoiceCard = observer(({ t, invoice, redirectToInvoiceViewPageCallback }) => (
  <Card fluid>
    <Card.Content>
      <Card.Header>
        <Label color={invoice.paymentStatus === InvoicePaymentStatus.PAID ? "green" : "red"} horizontal>
          {t(`billingCentral:${invoice.paymentStatusTranslationKey}`)}
        </Label>
        {t("billingCentral:invoiceId", { id: invoice.invoiceId })}
      </Card.Header>
      <Card.Description>
        <strong>{t("creationDate")}:</strong> {invoice.creationDts.format("lll")}
      </Card.Description>
    </Card.Content>
    {invoice.paymentStatus !== InvoicePaymentStatus.PAID && (
      <Card.Content extra>
        <Message warning>
          {t(
            invoice.creationDts.isBefore(moment().subtract(2, "days"))
              ? "billingCentral:unpaidInvoiceOlderThanTwoDaysMessage"
              : "billingCentral:unpaidInvoiceYoungerThanTwoDaysMessage",
          )}
        </Message>
      </Card.Content>
    )}
    <Card.Content extra>
      <InvoiceTable invoice={invoice} />
    </Card.Content>
    {typeof redirectToInvoiceViewPageCallback !== "undefined" && invoice.paymentStatus !== InvoicePaymentStatus.PAID && (
      <Card.Content extra textAlign="center">
        <Button color="green" size="large" onClick={() => redirectToInvoiceViewPageCallback(invoice.invoiceId)}>
          {t("billingCentral:makeAPayment")}
        </Button>
      </Card.Content>
    )}
  </Card>
));

InvoiceCard.propTypes = {
  t: PropTypes.func.isRequired,
  invoice: PropTypes.instanceOf(Invoice),
  redirectToInvoiceViewPageCallback: PropTypes.func,
};

export default withTranslation()(InvoiceCard);
